var Component = require("!../../../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../vue-loader/lib/selector?type=script&index=0!./checkbox.vue"),
  /* template */
  require("!!../../../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3d57fa57\"}!../../../../../../vue-loader/lib/selector?type=template&index=0!./checkbox.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-xpc/src/element-ui/packages/checkbox/src/checkbox.vue
// module id = 666
// module chunks = 228